import { action } from './utils';

export const SET_MAIN_BOUNDARY_ERROR = 'SET_MAIN_BOUNDARY_ERROR';
export const boundaryErrorActions = {
  setMainBoundaryError: (isError: boolean) => action(SET_MAIN_BOUNDARY_ERROR, { payload: isError }),
};
